import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { fetchProfessionsIfNeeded } from 'client/actions/tax/professions';
import 'client/styles/common.scss';

const propTypes = {
  children: PropTypes.element,
};

const defaultProps = {
  children: null,
};

class Deductions extends Component {
  static fetchData({ dispatch }) {
    return dispatch(fetchProfessionsIfNeeded());
  }

  render() {
    return (
      <div>
        {Children.only(this.props.children)}
      </div>
    );
  }
}

Deductions.propTypes = propTypes;
Deductions.defaultProps = defaultProps;
export default Deductions;
